import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

export const useCheckTossOrKbPay = () =>
  useDeviceInfoStore(
    (state) =>
      state.subDomain === SUB_DOMAIN.TOSS ||
      state.subDomain === SUB_DOMAIN.KB_PAY,
  );
